const baseSelector = state => state.features.candidates;

export const getCandidates = state => baseSelector(state).data;
export const getCandidatesIsLoading = state => baseSelector(state).isLoading;
export const getMoreCandidatesAreLoading = state => baseSelector(state).isLoadingMore;
export const getCandidatesPagination = state => baseSelector(state).pagination;
export const getSelectedCandidateDetails = state => baseSelector(state).selectedCandidateDetails;
export const getIsSelectedCandidateDetailsLoading = state => baseSelector(state).isSelectedCandidateDetailsLoading;
export const getCandidatesIsHidingOrUnhiding = state => baseSelector(state).isHidingOrUnhidingCandidates;
export const getCandidatesIsRating = state => baseSelector(state).isRatingCandidates;
export const getCandidatesNotesIsLoading = state => baseSelector(state).isLoadingNotes;
export const getCandidatesMoreNotesIsLoading = state => baseSelector(state).isLoadingMoreNotes;
export const getCandidatesNotes = state => baseSelector(state).notes.content;
export const getCandidatesNotesPagination = state => baseSelector(state).notes.pagination;
export const getCandidatesIsForward = state => baseSelector(state).isForwardCandidates;
export const getScreenerAnswersList = state => baseSelector(state).screenerAnswers.data;

export default {
  getCandidates,
  getCandidatesIsLoading,
  getMoreCandidatesAreLoading,
  getCandidatesPagination,
  getSelectedCandidateDetails,
  getIsSelectedCandidateDetailsLoading,
  getCandidatesIsHidingOrUnhiding,
  getCandidatesNotesIsLoading,
  getCandidatesNotes,
  getCandidatesNotesPagination,
  getCandidatesMoreNotesIsLoading,
  getCandidatesIsForward,
  getScreenerAnswersList,
};
